import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveBulletinVideoSuccess,
  saveBulletinVideoFailure,
  updateBulletinVideoSuccess,
  updateBulletinVideoFailure,
  deleteBulletinVideoSuccess,
  deleteBulletinVideoFailure,
  readBulletinVideoSuccess,
  readBulletinVideoFailure,
} from "./bulletinVideosActions";

import {
  saveBulletinVideo,
  updateBulletinVideo,
  deleteBulletinVideo,
  readBulletinVideos,
} from "./bulletinVideosAPI";

/* SAVE */
function* saveBulletinVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveBulletinVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveBulletinVideoSuccess(res.data));
      toast.success(res.message || "Bulletin Video Saved!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Save failed");
  } catch (error) {
    yield put(saveBulletinVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

/* UPDATE */
function* updateBulletinVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateBulletinVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateBulletinVideoSuccess(res.data));
      toast.success(res.message || "Bulletin Video Updated!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Update failed");
  } catch (error) {
    yield put(updateBulletinVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

/* DELETE */
function* deleteBulletinVideoSaga(action) {
  try {
    const res = yield call(deleteBulletinVideo, action.payload);

    if (res?.type === 1) {
      yield put(deleteBulletinVideoSuccess(action.payload));
      toast.success(res.message || "Bulletin Video Deleted!");
      if (action.callback) action.callback({ type: 1, data: action.payload });
    } else throw new Error(res?.error || "Delete failed");
  } catch (error) {
    yield put(deleteBulletinVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

/* READ */
function* readBulletinVideosSaga(action) {
  try {
    const res = yield call(readBulletinVideos, action.payload);

    if (res?.type === 1) {
      yield put(readBulletinVideoSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Read failed");
  } catch (error) {
    yield put(readBulletinVideoFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

/* WATCHER */
export default function* bulletinVideosWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_BULLETIN_VIDEO_REQUEST, saveBulletinVideoSaga);
  yield takeLatest(actionTypes.UPDATE_BULLETIN_VIDEO_REQUEST, updateBulletinVideoSaga);
  yield takeLatest(actionTypes.DELETE_BULLETIN_VIDEO_REQUEST, deleteBulletinVideoSaga);
  yield takeLatest(actionTypes.READ_BULLETIN_VIDEO_REQUEST, readBulletinVideosSaga);
}
